// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terms-form[data-v-7b4856d3]{padding-bottom:150px!important}", ""]);
// Exports
module.exports = exports;
